// `Object.hasOwn` (ES2022) is missing on the older browsers we still target in
// vite.config.ts (chrome87 / safari14 — for old Android/iOS webviews). esbuild
// only down-levels syntax, not runtime APIs, so a dependency that calls
// Object.hasOwn crashes there. This fills that one gap; if more ES2022+ API gaps
// surface in Sentry, prefer @vitejs/plugin-legacy + core-js over adding them here.
const objectHasOwnProperty = Object.prototype.hasOwnProperty;

if (!('hasOwn' in Object)) {
  Object.defineProperty(Object, 'hasOwn', {
    value(object: object, property: PropertyKey) {
      return Reflect.apply(objectHasOwnProperty, object, [property]);
    },
    configurable: true,
    enumerable: false,
    writable: true,
  });
}
